import * as React from 'react';
import { Slider } from 'wix-style-react-tpa';
import { TPAComponentsContext } from '../TPAComponentsConfig';
import { st, classes } from './Range.st.css';
import { ErrorMessageWrapper } from '../internal/ErrorMessageWrapper';
import { RangeDataHooks } from './types';
import uniqueId from '../../common/uniqueId';
import { shellClasses } from '../../common/shellClasses';
const formatValue = (value, format) => {
    const { locale = 'en', ...formatOptions } = format ?? {};
    return Intl.NumberFormat(locale, formatOptions).format(value);
};
export const Range = ({ value, min = 0, max, format, label, disabled, minAriaLabel, maxAriaLabel, onChange, onAfterChange, errorMessage, errorAppearance, ...other }) => {
    const sliderId = React.useMemo(() => uniqueId('slider-id_'), []);
    const errorMessageId = React.useMemo(() => uniqueId('error-message'), []);
    const { rtl } = React.useContext(TPAComponentsContext);
    const changeHandler = React.useCallback((range) => {
        onChange && onChange(range);
    }, [onChange]);
    const stStates = { error: !!errorMessage };
    return (React.createElement(ErrorMessageWrapper, { visible: !!errorMessage,
        message: errorMessage,
        errorAppearance,
        messageId: errorMessageId,
        className: st(classes.root, stStates, other.className),
        'data-hook': other['data-hook'] },
        React.createElement("fieldset", { className: classes.container },
            label && (React.createElement("legend", { "data-hook": RangeDataHooks.Label, className: classes.label }, label)),
            React.createElement("div", { className: classes.sliderWrapper },
                React.createElement(Slider, { id: sliderId, className: st(classes.slider, { rtl }, shellClasses.hasCustomFocus), onChange: changeHandler, onAfterChange: onAfterChange, min: min, max: max, value: value || [min, max], displayMarks: false, disabled: disabled, displayTooltip: false, rtl: rtl, ariaLabelForHandle: [minAriaLabel, maxAriaLabel] })),
            React.createElement("div", { className: classes.rangeValues },
                React.createElement("span", { "data-hook": RangeDataHooks.SelectedMinValue }, formatValue(value ? value[0] : min, format)),
                React.createElement("span", { "data-hook": RangeDataHooks.SelectedMaxValue }, formatValue(value ? value[1] : max, format))))));
};
Range.displayName = 'Range';
//# sourceMappingURL=Range.js.map